import React, { useEffect, useRef, useState } from "react";

const LazyBackground = ({ src, children, className, style = {}, gradient, ...rest }) => {
  const ref = useRef();
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting) {
          setLoaded(true);
          observer.disconnect();
        }
      },
      { threshold: 0.1 }
    );

    if (ref.current) observer.observe(ref.current);

    return () => observer.disconnect();
  }, []);

  return (
    <div
      ref={ref}
      className={className}
      style={{
        backgroundImage: loaded
          ? (gradient ? `${gradient}, url(${src})` : `url(${src})`)
          : "none",
        ...style
      }}
      {...rest}
    >
      {children}
    </div>
  );
};

export default LazyBackground;
